import { createStandardAction } from 'typesafe-actions'

export const APP_INITIALIZED = 'app/APP_INITIALIZED'
export const INITIALIZE_ANALYTICS = 'app/INITIALIZE_ANALYTICS'
export const SET_FEATURE_FLAGS = 'app/SET_FEATURE_FLAGS'

export const appInitialized = createStandardAction(APP_INITIALIZED)()
export const initializeAnalytics = createStandardAction(INITIALIZE_ANALYTICS)()



// WEBPACK FOOTER //
// ./src/state/app/actions.ts